import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, Shapeable } from '@shapeable/types';
import { applyBannerThumbnailSize, classNames, firstImageProperty } from '@shapeable/utils';
import { EntityBubbleImage, EntityHalfBanner, EntityHalfBannerProps, EntityImage, Image, ImageAsset, OrganisationCardImage } from '@shapeable/ui';
import { Space } from '@shapeable/doing-co-types';
import { breakpoints, theme } from '@shapeable/theme';

const cls = classNames('space-half-banner');

// -------- Types -------->

// -------- Props -------->

export type SpaceHalfBannerProps = Omit<EntityHalfBannerProps, 'entity'> & Classable & HasChildren & {
  entity?: Space;
};

export const SpaceHalfBannerDefaultProps: Omit<SpaceHalfBannerProps, 'entity'> = {
};

type ContainerProps = {

};

const ContainerStyles = breakpoints({
  base: css`
    box-shadow: 2px 2px 4px rgba(0,0,0,0.1);
    color: ${theme.COLOR('sub')};
  `,
});


const LogoImageStyles = breakpoints({
  base: css`
    object-fit: contain !important;
    padding: ${theme.UNIT(0.5)};
  `,
});

const My = {
  Container: styled(EntityHalfBanner)<ContainerProps>`${ContainerStyles}`,
    LogoImage: styled(Image)`${LogoImageStyles}`,
};

export const SpaceHalfBanner: Shapeable.FC<SpaceHalfBannerProps> = (props) => {
  const { className, children, entity, image: providedImage, showImage, ...rest } = props;

  if (!entity) {
    return null;
  }

  const logoImage = firstImageProperty(entity, [
    'logo', 
    'openGraph.image.thumbnails.card', 
    'openGraph.image'
  ])

  const bannerImage = applyBannerThumbnailSize('halfBanner')(entity?.banner);

  const hasBanner = !!bannerImage?.image || !!bannerImage?.thumbnail;

  const image: React.ReactNode = providedImage || (!!logoImage
    ? <My.LogoImage image={logoImage} />
    : hasBanner
      ? <ImageAsset entity={bannerImage} />
      : <EntityBubbleImage size={120} alwaysShowIcon iconColors={{ fill: 'primary ' }} entity={entity} />);
  
  return (
    <My.Container
      {...rest}
      className={cls.name(className)}
      entity={entity}
      labelDeriver={() => 'TOWN TEAM'}
      showTypeHeader={true}
      image={image}
      showImage={showImage}
      backgroundColor={'canvas'}
      aspectRatio={{ base: 4/3, tablet: 16/9 }}
      colors={{
        background: 'primary',
        text: 'light',
      }}
    >
      {children}
    </My.Container>
  );
};

SpaceHalfBanner.cls = cls;